import { render, staticRenderFns } from "./PaisDetalle.vue?vue&type=template&id=cfbd1944"
import script from "./PaisDetalle.vue?vue&type=script&lang=js"
export * from "./PaisDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports